import { Pen } from "components/Icon"
import { Button } from "components/Button"
import { useTranslator } from "components/Translator"
import { AlbumDeleteButton } from "domains/album/AlbumDeleteButton"

export const AlbumActions = ({ album, onDelete }) => {
  const translator = useTranslator()

  return (
    <>
      <Button
        variant="outline"
        color="secondary"
        iconLeft={<Pen className="w-4" />}
        href={{
          route: "app_user_album_edit",
          params: { mediaAlbumId: album.id },
        }}
      >
        {translator.trans("AlbumActions.edit", null, "components")}
      </Button>
      <AlbumDeleteButton album={album} onSuccess={onDelete} variant="outline" />
    </>
  )
}
